import { render, staticRenderFns } from "./OrgAnaBlock.vue?vue&type=template&id=3603ad6a&scoped=true"
import script from "./OrgAnaBlock.vue?vue&type=script&lang=js"
export * from "./OrgAnaBlock.vue?vue&type=script&lang=js"
import style0 from "./OrgAnaBlock.vue?vue&type=style&index=0&id=3603ad6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603ad6a",
  null
  
)

export default component.exports